import { modelOptions, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, SchemaBase, getDefaultSchemaOptions, SchemaConstructorArgs } from "../../schemaBase.js";

const SCHEMA_KEY = "ContactInfo" as const;

/**
 * This has been supplanted by our CRM systems that are independent of this. And it isn't up to date anyway
 * @deprecated
 */
@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<ContactInfo>>(...addSchemaKeyHook(SCHEMA_KEY))
export class ContactInfo extends SchemaBase<ContactInfo> {
    static schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => String, required: false })
    public email?: string;

    @prop({ type: () => String, required: false })
    public phone?: string;

    @prop({ type: () => String, required: false })
    public other?: string;

    @prop({ type: () => String, required: false })
    public other2?: string;

    static getters = {} as const satisfies Record<string, (self: ContactInfo) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<ContactInfo>) {
        super(properties);
        Object.assign(this, properties);
    }
}
